import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import 'react-quill/dist/quill.snow.css';
import Video from '../components/Video';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
const TOPICS_REQUEST = '/api/v1/tutorials/';

const EMPTY_CPD_QUIZES = [
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  }
];

@withRouter
@inject('userStore')
@inject('topicsStore')
@inject('alertStore')
@inject('examPrepHeaderStore')
@observer
class ExamPrepTopic extends Component {
  extractContent = description => {
    const span = document.createElement('span');
    span.innerHTML = description;
    return span.textContent || span.innerText;
  }

  componentWillMount() {
    const {topicsStore, match, examPrepHeaderStore: {setTopic}} = this.props;
    const id = match.params.id;

    if(id) {
      new HttpClient().get(`${TOPICS_REQUEST}${id}`).then(data => {
        const topic = data.body.data.tutorial;
        const topicWithVideo = {
          ...topic,
          tutorial_videos_attributes: topic.videos,
          podcasts_attributes: topic.podcasts
        }
        const withDescription = !!this.extractContent(topic.description);

        if (topic.tutorial_type !== 'regular') {
          setTopic(topic);
        }
        const spd_quizzes = topic.spd_quizzes;
        let sortedQuizz = (spd_quizzes || []).length > 0 ? _.sortBy(spd_quizzes, 'id') : EMPTY_CPD_QUIZES;
          sortedQuizz = sortedQuizz.map(quiz => {
            const quizOptions = quiz.options ? quiz.options : [];
            const options = quizOptions.map(option => JSON.parse((option || '').replaceAll('=>', ':')));

            return {
              ...quiz,
              options
            };
          });
        const topicWithSortedQuizz = {
          ...topicWithVideo,
          withDescription,
          spd_quizzes: sortedQuizz
        };
        topicsStore.setTopic(topicWithSortedQuizz);

      }).catch( (e) => {
        if(e.status === 403) {
          this.props.history.push('/settings/payments');
        }
      });
    }
  }

  componentWillUnmount() {
    this.props.topicsStore.initNewTopic();
  }

  render() {
    const {topicsStore} = this.props;

    return (
      <section className="section topic-edit" style={{overflow: 'scroll'}}>
        <div className="container-fluid">
          <div className="tab-container">
            <div className="row justify-content-center">
              <h3 className='container-header' style={{textTransform: 'capitalize'}}>{topicsStore.topic.title}</h3>
            </div>
          </div>
          <div className="row">
            <div className="container justify-content-center">
              <div className="edit-container">
                <Video topic={topicsStore.topic} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ExamPrepTopic;



// WEBPACK FOOTER //
// ./src/modules/topic/containers/ExamPrepTopic.js